// extracted by css-extract-rspack-plugin
export default {"lettersContainer":"letters-container--glfRfy8ybkIAwmia","letters":"letters--nFz0K3YabsVGsG_I","lettersGroup":"letters-group--MJt1lWkZxQsKxArs"};